/**
 * Antiek & Antiquiteiten 2.0 — Theme JavaScript
 * Cart Drawer, Inquiry Popup, Shipping Calculator, AJAX Add to Cart
 */

(function () {
  'use strict';

  /* ==========================================================================
     CART DRAWER
     ========================================================================== */
  var cartDrawer = document.querySelector('[data-cart-drawer]');
  var cartToggle = document.querySelector('[data-cart-toggle]');

  // cachedCart: holds the latest cart data so we can check it without extra fetches
  var cachedCart = null;

  function openCartDrawer() {
    if (cartDrawer) {
      cartDrawer.hidden = false;
      document.body.style.overflow = 'hidden';
    }
  }

  function closeCartDrawer() {
    if (cartDrawer) {
      cartDrawer.hidden = true;
      document.body.style.overflow = '';
    }
  }

  // Use event delegation for close buttons (works even after innerHTML updates)
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-cart-drawer-close]')) {
      closeCartDrawer();
    }
  });

  if (cartToggle) {
    cartToggle.addEventListener('click', function (e) {
      e.preventDefault();
      openCartDrawer();
    });
  }

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      closeCartDrawer();
      closeInquiryPopup();
    }
  });

  /* ---------- Cart Count ---------- */
  function updateCartCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      if (count > 0) {
        el.textContent = count;
        el.style.display = '';
      } else {
        el.style.display = 'none';
      }
    });
  }

  /* ---------- Build Drawer HTML from cart data ---------- */
  function formatMoney(cents) {
    return new Intl.NumberFormat('nl-NL', { style: 'currency', currency: 'EUR' }).format(cents / 100);
  }

  function buildDrawerBody(cart) {
    var bodyEl = cartDrawer ? cartDrawer.querySelector('[data-cart-drawer-body]') : null;
    var footerEl = cartDrawer ? cartDrawer.querySelector('[data-cart-drawer-footer]') : null;
    if (!bodyEl) return;

    if (cart.item_count === 0) {
      bodyEl.innerHTML = '<div class="cart-drawer__empty" data-cart-drawer-empty>'
        + '<svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1"><path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 01-8 0"/></svg>'
        + '<p>Uw winkelwagen is leeg.</p>'
        + '<a href="/collections/all" class="btn btn--primary">Bekijk collectie</a>'
        + '</div>';
      if (footerEl) footerEl.style.display = 'none';
      return;
    }

    var itemsHtml = '<div class="cart-drawer__items" data-cart-drawer-items>';
    cart.items.forEach(function (item, index) {
      var lineIndex = index + 1;
      var imgHtml = item.image
        ? '<img src="' + item.image + '" alt="' + item.title.replace(/"/g, '&quot;') + '" loading="lazy">'
        : '';

      // Build metafields display from line item properties
      var metaHtml = '';
      if (item.properties) {
        Object.keys(item.properties).forEach(function (key) {
          if (item.properties[key] && key.charAt(0) !== '_') {
            metaHtml += '<div><span style="display:inline-block;width:90px;">' + key + '</span>: ' + item.properties[key] + '</div>';
          }
        });
      }

      itemsHtml += '<div class="cart-drawer__item" data-cart-item data-line="' + lineIndex + '">'
        + '<div class="cart-drawer__item-image">' + imgHtml + '</div>'
        + '<div class="cart-drawer__item-info">'
        + '<a href="' + item.url + '" class="cart-drawer__item-title">' + item.product_title + '</a>'
        + (metaHtml ? '<div style="font-size:12px;color:#888;margin-top:4px;line-height:1.6;">' + metaHtml + '</div>' : '')
        + '<p class="cart-drawer__item-price">' + formatMoney(item.price) + '</p>'
        + '<div class="cart-drawer__item-actions">'
        + '<div class="cart-drawer__quantity"><span>Aantal: ' + item.quantity + '</span></div>'
        + '<button class="cart-drawer__remove" data-remove-item data-line="' + lineIndex + '" aria-label="Verwijderen">'
        + '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><polyline points="3 6 5 6 21 6"/><path d="M19 6v14a2 2 0 01-2 2H7a2 2 0 01-2-2V6m3 0V4a2 2 0 012-2h4a2 2 0 012 2v2"/></svg>'
        + '</button>'
        + '</div>'
        + '</div>'
        + '</div>';
    });
    itemsHtml += '</div>';

    bodyEl.innerHTML = itemsHtml;

    // Update footer
    if (footerEl) {
      footerEl.style.display = '';
      var totalEl = footerEl.querySelector('[data-cart-drawer-total]');
      if (totalEl) totalEl.textContent = formatMoney(cart.total_price);
    }
  }

  /* ---------- Remove item (event delegation) ---------- */
  document.addEventListener('click', function (e) {
    var removeBtn = e.target.closest('[data-remove-item]');

    if (removeBtn) {
      e.preventDefault();
      var line = parseInt(removeBtn.getAttribute('data-line'));
      changeCartItem(line, 0);
    }
  });

  function changeCartItem(line, quantity) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    })
    .then(function (r) { return r.json(); })
    .then(function (cart) {
      cachedCart = cart;
      updateCartCount(cart.item_count);
      buildDrawerBody(cart);
    })
    .catch(function () { window.location.reload(); });
  }

  /* ---------- AJAX Add to Cart ---------- */
  var addToCartForms = document.querySelectorAll('[data-add-to-cart-form]');
  addToCartForms.forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var submitBtn = form.querySelector('[data-add-to-cart]');
      var originalText = submitBtn.innerHTML;
      var formData = new FormData(form);
      var variantId = parseInt(formData.get('id'));

      // Check if this product variant is already in the cart
      if (cachedCart && cachedCart.items.some(function (item) {
        return item.variant_id === variantId;
      })) {
        // Already in cart — show message, open drawer, do NOT add again
        var _lang = document.documentElement.lang || 'nl';
        submitBtn.innerHTML = _lang === 'de' ? '&#10003; Bereits im Warenkorb' : _lang === 'en' ? '&#10003; Already in cart' : '&#10003; Al in winkelwagen';
        submitBtn.disabled = true;
        buildDrawerBody(cachedCart);
        openCartDrawer();
        setTimeout(function () {
          closeCartDrawer();
          submitBtn.innerHTML = originalText;
          submitBtn.disabled = false;
        }, 3000);
        return;
      }

      // Not yet in cart — proceed with adding
      submitBtn.disabled = true;
      submitBtn.innerHTML = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" class="spin"><circle cx="12" cy="12" r="10" stroke-dasharray="60" stroke-dashoffset="20"/></svg>';

      fetch('/cart/add.js', { method: 'POST', body: formData })
        .then(function (r) {
          if (!r.ok) throw new Error('Add to cart failed');
          return r.json();
        })
        .then(function () {
          // Get updated cart data
          return fetch('/cart.js');
        })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          cachedCart = cart;
          updateCartCount(cart.item_count);
          buildDrawerBody(cart);
          submitBtn.innerHTML = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="20 6 9 17 4 12"/></svg> Toegevoegd!';
          submitBtn.disabled = true;
          openCartDrawer();
          setTimeout(function () {
            closeCartDrawer();
            submitBtn.innerHTML = originalText;
            submitBtn.disabled = false;
          }, 3000);
        })
        .catch(function () {
          submitBtn.innerHTML = originalText;
          submitBtn.disabled = false;
          form.submit();
        });
    });
  });

  /* ---------- Load cart on page load ---------- */
  fetch('/cart.js')
    .then(function (r) { return r.json(); })
    .then(function (cart) {
      cachedCart = cart;
      updateCartCount(cart.item_count);
      buildDrawerBody(cart);
    });

  /* ==========================================================================
     INQUIRY POPUP
     ========================================================================== */
  var inquiryPopup = document.querySelector('[data-inquiry-popup]');
  var inquiryTrigger = document.querySelector('[data-inquiry-trigger]');

  function openInquiryPopup() {
    if (inquiryPopup) { inquiryPopup.hidden = false; document.body.style.overflow = 'hidden'; }
  }
  function closeInquiryPopup() {
    if (inquiryPopup) { inquiryPopup.hidden = true; document.body.style.overflow = ''; }
  }

  if (inquiryTrigger) {
    inquiryTrigger.addEventListener('click', function (e) { e.preventDefault(); openInquiryPopup(); });
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-inquiry-popup-close]')) closeInquiryPopup();
  });

  /* ==========================================================================
     SHIPPING CALCULATOR
     ========================================================================== */
  var shippingSelect = document.querySelector('[data-shipping-country]');
  var shippingResult = document.querySelector('[data-shipping-result]');
  var shippingPrice = document.querySelector('[data-shipping-price]');
  var shippingOnRequest = document.querySelector('[data-shipping-on-request]');
  var shippingRates = {
    'NL': '€ 75 - € 150', 'BE': '€ 95 - € 175',
    'DE': '€ 125 - € 250', 'AT': '€ 195 - € 350',
    'FR': '€ 175 - € 325', 'GB': '€ 250 - € 450',
    'CH': '€ 225 - € 400', 'LU': '€ 95 - € 175',
    'DK': '€ 195 - € 350'
  };

  if (shippingSelect) {
    shippingSelect.addEventListener('change', function () {
      var country = this.value;
      if (!country) {
        if (shippingResult) shippingResult.hidden = true;
        if (shippingOnRequest) shippingOnRequest.hidden = true;
        return;
      }
      if (country === 'OTHER' || !shippingRates[country]) {
        if (shippingResult) shippingResult.hidden = true;
        if (shippingOnRequest) shippingOnRequest.hidden = false;
      } else {
        if (shippingResult) { shippingResult.hidden = false; if (shippingPrice) shippingPrice.textContent = shippingRates[country]; }
        if (shippingOnRequest) shippingOnRequest.hidden = true;
      }
    });
  }

  /* ==========================================================================
     MOBILE MENU
     ========================================================================== */
  var menuToggle = document.querySelector('[data-menu-toggle]');
  var mobileMenu = document.querySelector('[data-mobile-menu]');
  if (menuToggle && mobileMenu) {
    menuToggle.addEventListener('click', function () {
      var isOpen = !mobileMenu.hidden;
      mobileMenu.hidden = isOpen;
      document.body.style.overflow = isOpen ? '' : 'hidden';
      menuToggle.innerHTML = isOpen
        ? '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><line x1="3" y1="6" x2="21" y2="6"/><line x1="3" y1="12" x2="21" y2="12"/><line x1="3" y1="18" x2="21" y2="18"/></svg>'
        : '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>';
    });
  }

  document.querySelectorAll('[data-mobile-submenu-toggle]').forEach(function (toggle) {
    toggle.addEventListener('click', function () {
      var submenu = toggle.nextElementSibling;
      if (submenu && submenu.hasAttribute('data-mobile-submenu')) {
        submenu.hidden = !submenu.hidden;
        var svg = toggle.querySelector('svg');
        if (svg) svg.style.transform = submenu.hidden ? '' : 'rotate(180deg)';
      }
    });
  });

  /* ==========================================================================
     SEARCH OVERLAY
     ========================================================================== */
  var searchToggle = document.querySelector('[data-search-toggle]');
  var searchOverlay = document.querySelector('[data-search-overlay]');
  var searchInput = document.querySelector('[data-search-input]');
  if (searchToggle && searchOverlay) {
    searchToggle.addEventListener('click', function () { searchOverlay.hidden = false; if (searchInput) searchInput.focus(); });
  }
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-search-close]')) {
      if (searchOverlay) searchOverlay.hidden = true;
    }
  });

  /* ==========================================================================
     COLLECTION FILTERS & SORT
     ========================================================================== */
  var filterToggle = document.querySelector('[data-filter-toggle]');
  var filterPanel = document.querySelector('[data-filter-panel]');
  if (filterToggle && filterPanel) {
    filterToggle.addEventListener('click', function () { filterPanel.hidden = !filterPanel.hidden; });
  }

  var sortSelect = document.querySelector('[data-sort-select]');
  if (sortSelect) {
    sortSelect.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', this.value);
      window.location.href = url.toString();
    });
  }

  /* ==========================================================================
     SMOOTH SCROLL
     ========================================================================== */
  document.querySelectorAll('a[href^="#"]').forEach(function (anchor) {
    anchor.addEventListener('click', function (e) {
      var target = document.querySelector(this.getAttribute('href'));
      if (target) { e.preventDefault(); target.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
    });
  });

  /* ==========================================================================
     LAZY ANIMATION ON SCROLL
     ========================================================================== */
  if ('IntersectionObserver' in window) {
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) { entry.target.classList.add('is-visible'); observer.unobserve(entry.target); }
        });
      },
      { threshold: 0.1 }
    );
    document.querySelectorAll('.product-card, .usp-bar__item, .blog-card, .contact-page__about-block').forEach(function (el) { observer.observe(el); });
  }

  /* ==========================================================================
     SPIN ANIMATION
     ========================================================================== */
  var style = document.createElement('style');
  style.textContent = '@keyframes spin { from { transform: rotate(0deg); } to { transform: rotate(360deg); } } .spin { animation: spin 0.8s linear infinite; }';
  document.head.appendChild(style);

})();

/* ========== LANGUAGE PERSISTENCE ========== */
(function() {
  var langPrefixes = ['/de-', '/en-gb', '/nl'];

  function getCurrentLang() {
    var path = window.location.pathname;
    if (path.indexOf('/de-') === 0) return 'de';
    if (path.indexOf('/en-gb') === 0) return 'en';
    return 'nl';
  }

  function getLangCookie() {
    var match = document.cookie.match(/preferred_lang=([^;]+)/);
    return match ? match[1] : null;
  }

  function setLangCookie(lang) {
    document.cookie = 'preferred_lang=' + lang + '; path=/; max-age=31536000';
  }

  // Als vlagje wordt geklikt, sla taal op in cookie
  document.querySelectorAll('[id^="lang-form-"]').forEach(function(form) {
    form.addEventListener('submit', function() {
      var locale = form.querySelector('input[name="locale_code"]');
      if (locale) setLangCookie(locale.value.substring(0, 2));
    });
  });

  // Bij paginaload: als cookie taal verschilt van huidige URL, redirect
  var cookieLang = getLangCookie();
  var currentLang = getCurrentLang();
  if (cookieLang && cookieLang !== currentLang) {
    var path = window.location.pathname;
    var newPath;
    if (cookieLang === 'de') newPath = path.replace(/^\/(en-gb|nl)/, '/de-de');
    else if (cookieLang === 'en') newPath = path.replace(/^\/(de-[a-z]+|nl)/, '/en-gb');
    else newPath = path.replace(/^\/(de-[a-z]+|en-gb)/, '');
    if (newPath && newPath !== path) window.location.replace(newPath + window.location.search);
  }
})();

/* ==========================================================================
   COLLECTION FILTERS — URL-based filtering
   ========================================================================== */
(function () {
  var filterSelects = document.querySelectorAll('[data-filter-select]');
  if (!filterSelects.length) return;

  filterSelects.forEach(function (select) {
    select.addEventListener('change', function () {
      var url = new URL(window.location.href);

      // Verwijder alle bestaande filter params
      var keysToDelete = [];
      url.searchParams.forEach(function (val, key) {
        if (key.indexOf('filter.') === 0) keysToDelete.push(key);
      });
      keysToDelete.forEach(function (k) { url.searchParams.delete(k); });

      // Voeg alle actieve filterwaarden toe
      filterSelects.forEach(function (sel) {
        if (sel.value) {
          var paramName = sel.getAttribute('name');
          if (paramName) url.searchParams.set(paramName, sel.value);
        }
      });

      // Reset naar pagina 1
      url.searchParams.delete('page');

      window.location.href = url.toString();
    });
  });
})();

/* ==========================================================================
   PRODUCT GALLERY — Thumbnails + Mobile swipe
   ========================================================================== */
(function () {
  var mainImage = document.getElementById('main-product-image');
  if (!mainImage) return;

  var thumbnails = document.querySelectorAll('.product-page__thumbnail');
  if (!thumbnails.length) return;

  // Bouw de afbeeldingenlijst op uit de thumbnails
  var images = Array.from(thumbnails).map(function (btn) {
    return btn.getAttribute('data-thumbnail');
  });

  // Bepaal de startindex op basis van welke thumbnail actief is
  var currentIndex = 0;
  thumbnails.forEach(function (btn, i) {
    if (btn.classList.contains('product-page__thumbnail--active')) {
      currentIndex = i;
    }
  });

  // Zorg dat de grote foto overeenkomt met de actieve thumbnail bij laden
  mainImage.src = images[currentIndex];

    function goTo(index) {
    if (index < 0) index = images.length - 1;
    if (index >= images.length) index = 0;
    currentIndex = index;
    mainImage.srcset = '';
    mainImage.src = images[currentIndex];
    thumbnails.forEach(function (b, i) {
      b.classList.toggle('product-page__thumbnail--active', i === currentIndex);
    });
  }


  // Thumbnail click — werkt voor alle thumbnails
  thumbnails.forEach(function (btn, i) {
    btn.addEventListener('click', function () {
      goTo(i);
    });
  });

  // Touch swipe op de grote foto (werkt ook op desktop met muis-drag)
  var touchStartX = 0;
  var touchEndX = 0;

  mainImage.addEventListener('touchstart', function (e) {
    touchStartX = e.changedTouches[0].screenX;
  }, { passive: true });

  mainImage.addEventListener('touchend', function (e) {
    touchEndX = e.changedTouches[0].screenX;
    var diff = touchStartX - touchEndX;
    if (Math.abs(diff) > 40) {
      if (diff > 0) {
        goTo(currentIndex + 1); // swipe links = volgende foto
      } else {
        goTo(currentIndex - 1); // swipe rechts = vorige foto
      }
    }
  }, { passive: true });
})();
